export default "__VITE_ASSET__BwsnvGhN__"